'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.integrations = twentyninetimes.integrations || function () {

	function init() {
		let integration_wrapper     = document.querySelector('.integrations-page'),
            load_more_btns          = document.querySelectorAll('.js-load-more-integrations'),
            search_form             = document.getElementById('js-search-form-integrations');

        if ( load_more_btns.length > 0 ) {
            fetch(templateUrl+'/integrations.json')
                .then(response => response.json())
                .then(json => {
                    const data = json;
                    load_more_integrations(load_more_btns, data);
                });
        }

        if ( integration_wrapper.length > 0 ) {
            integration_wrapper.addEventListener('click', function(event) {
                let integration = event.target.closest('a[data-create-integration]');

                if (!integration) return;
                if (!integration_wrapper.contains(integration)) return;

                event.preventDefault();

                var integration_data = JSON.stringify(integration.dataset);

                console.log(integration.dataset);

                create_new_integration(integration_data);
            }, false);
        }

        if ( search_form.length > 0 ) {
            search_integrations(search_form);
        }
	}

    function load_more_integrations(btns, data) {
        btns.forEach(btn => {
            btn.addEventListener('click', function(e) {
                e.stopPropagation();

                var btn_data        = this.dataset,
                    letter          = btn_data.letter,
                    per_page        = btn_data.ratio,
                    amount_current  = btn_data.amount,
                    amount_total    = btn_data.total,
                    amount_left     = amount_total - amount_current,
                    amount_get      = amount_left <= per_page ? amount_left : per_page,
                    amount_new;

                    // console.log(per_page);
                    // console.log(amount_get);

                if ( amount_left <= per_page ) 
                    btn.parentNode.removeChild(btn);

                amount_new = +amount_current + +amount_get;

                var letter_section = document.getElementById(letter),
                    list = letter_section.querySelector('.list-integration__inner'),
                    new_apps = data[letter].slice(amount_current, amount_new);

                new_apps.forEach(app => {
                    var div = document.createElement('div'),
                        app_class = app['highlight'] == true ? ' item-integration--highlight' : '',
                        app_link  = app['link'] != '' ? app['link'] : '';

                    div.setAttribute('class', 'item-integration'+app_class+' scroll-item js-lazy-load col-xs-6 col-sm-4 col-md-3');
                    div.setAttribute('data-slug', app['slug']);
                    div.innerHTML = app_link != ''
                        ? '<a href="'+app_link+'" class="item-integration__inner"><div class="item-integration__content"><figure class="item-integration__image"><img data-src="'+app['image']+'"></figure><h4 class="item-integration__header">'+app['title']+'</h4></div></a>'
                        : '<a href="" class="item-integration__inner" data-create-integration data-title="'+app['title']+'" data-slug="'+app['slug']+'" data-logo="'+app['image'].split('?')[0]+'"><div class="item-integration__content"><figure class="item-integration__image"><img data-src="'+app['image']+'"></figure><h4 class="item-integration__header">'+app['title']+'</h4></div></a>';

                    list.appendChild(div);
                });

                setTimeout(function() {
                    var newly_added_apps = list.querySelectorAll('.item-integration:not(.in-view)');
                    twentyninetimes.inView.init(newly_added_apps);
                }, 0);

                this.setAttribute('data-amount', amount_new);
            });
        });
    }

    function create_new_integration(data) {
        // https://getbutterfly.com/how-to-replace-jquery-ajax-with-vanilla-javascript-in-wordpress/
        var xhr             = new XMLHttpRequest(),
            method          = 'POST',
            post_type       = 'integration',
            url             = load_more_params.ajaxurl,
            action          = 'create_integration';

        xhr.open(method, url, true);
        //xhr.setRequestHeader('X-WP-Nonce', my_restapi_details.nonce);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
        xhr.send('action='+action+'&integration='+data);

        xhr.onload = function() {
            if (xhr.status >= 200 && xhr.status < 400) {
                // If successful

                var integration_url = xhr.response;

                console.log(integration_url);

                if ( !integration_url ) return;

                window.location.href = integration_url;

            } else {
                // If fail
                console.log('fejl');
            }
        };

        xhr.onerror = function() {
            alert("Something went wrong... Please try again later");
        };
    }

    function search_integrations(search_form) {
        var search_field    = search_form.querySelector('.search-field'),
            search_results  = search_form.querySelector('.search-form-results'),
            searchTimeout,
            currentFocus;

        search_field.addEventListener('input', function() {
            if (searchTimeout != undefined) clearTimeout(searchTimeout);
                searchTimeout = setTimeout(get_integrations, 250);

            currentFocus = -1;
        });

        function get_integrations() {
            var field_value = search_field.value;

            if ( field_value == '' ) {
                setTimeout(function() {
                    search_results.innerHTML = '';
                }, 300)
                search_results.classList.remove('active');

                return;
            }

            if ( field_value.length < 2 ) return;

            var first_char  = field_value.charAt(0).toUpperCase();

            fetch(templateUrl+'/integrations.json')
                .then(response => response.json())
                .then(json => {
                    var data = json,
                        results = [],
                        index,
                        integrations;

                    first_char = !isNaN(first_char) ? '#' : first_char;
                    integrations = data[first_char];

                    for (var prop in data) {
                        data[prop].forEach(integration => {
                            if (integration && integration['title'] && integration['title'].toUpperCase().indexOf(field_value.toUpperCase()) !== -1) {
                                results.push(integration);
                            }
                        })
                    }

                    // integrations.forEach(integration => {
                        
                    // });

                    search_results.innerHTML = '';

                    if ( results.length > 0 ) {
                        results.forEach(result => {
                            var li                  = document.createElement('LI'),
                                a                   = document.createElement('A'),
                                integration_link    = result['link'],
                                integration_logo    = result['image'],
                                integration_title   = result['title'],
                                integration_slug    = result['slug'];

                            if ( integration_link == '' ) {
                                a.setAttribute('data-create-integration', '');
                            }

                            li.setAttribute('id', integration_slug);

                            a.setAttribute('href', integration_link);
                            a.setAttribute('data-title', integration_title);
                            a.setAttribute('data-slug', integration_slug);
                            a.setAttribute('data-logo', integration_logo.split('?')[0]);

                            a.innerHTML = '<figure><img src="'+integration_logo+'"></figure><span>'+integration_title+'</span>';

                            li.appendChild(a);

                            search_results.appendChild(li);
                        });
                    } else {
                        var span = document.createElement('SPAN');
                        span.setAttribute('class', 'error');
                        span.innerHTML = 'Sorry, we found no integrations for "'+field_value+'"';

                        search_results.appendChild(span);
                    }


                    //console.log(data);

                    //console.log(results);
                });
        
            if ( !search_results.classList.contains('active') ) {
                search_results.classList.add('active');
            }
        }

        /*execute a function presses a key on the keyboard:*/
        search_field.addEventListener("keydown", function(e) {
            var x = search_results;

            if (x) x = x.getElementsByTagName("li");

            if ( !x ) return;

            //console.log(x);

            if (e.keyCode == 40) {
                e.preventDefault(); // Prevent cursor from moving around in input field
                /*If the arrow DOWN key is pressed,
                increase the currentFocus variable:*/
                e.preventDefault();
                currentFocus++;
                /*and and make the current item more visible:*/
                addActive(x);
            } else if (e.keyCode == 38) {
                e.preventDefault(); // Prevent cursor from moving around in input field
                /*If the arrow UP key is pressed,
                decrease the currentFocus variable:*/
                if ( currentFocus == 0 ) {
                    /* If already is first option, remove active state, focus input and set value to start value */
                    currentFocus = -1;
                    removeActive(x);
                    search_field.removeAttribute('aria-activedescendant');
                } else {
                    currentFocus--;

                    /*and and make the current item more visible:*/
                    addActive(x);
                }
            } else if (e.keyCode == 13) {
                /*If the ENTER key is pressed, prevent the form from being submitted,*/
                e.preventDefault();
                if (currentFocus > -1) {
                    /*and simulate a click on the "active" item:*/
                    if (x) x[currentFocus].querySelector('a').click();
                } else {
                    if (x.length == 1) {
                       x[0].querySelector('a').click(); 
                    } else if ( x.length > 1 ) {
                        currentFocus = 0;
                        addActive(x);
                    } else {
                        // DO NOTHING
                    }
                }
            } else if (e.keyCode == 27) {
                /*If the ESC key is pressed, execute a function;*/
                e.preventDefault();
                closeAllLists();
            }
        });

        function scrollToElementD(x){
          var topPos = x.offsetTop + 10,
            elm_outer = search_results.clientHeight / 2;
            console.log(elm_outer);
          search_results.scrollTop = topPos-elm_outer;
        }

        function addActive(x) {
            /*a function to classify an item as "active":*/
            if (!x) return false;
            //console.log(x);
            /*start by removing the "active" class on all items:*/
            removeActive(x);
            if (currentFocus >= x.length) currentFocus = 0;
            if (currentFocus < 0) currentFocus = (x.length - 1);
            console.log(x[currentFocus]);
            //x[currentFocus].querySelector('a').focus();
            /*add class "autocomplete-active":*/
            x[currentFocus].classList.add("autocomplete-active");
            var current_id = x[currentFocus].getAttribute('id');
            search_field.setAttribute('aria-activedescendant', current_id);
            scrollToElementD(x[currentFocus]);
        }
        function removeActive(x) {
            /*a function to remove the "active" class from all autocomplete items:*/
            for (var i = 0; i < x.length; i++) {
                x[i].classList.remove("autocomplete-active");
            }
        }

        function closeAllLists() {
            /*close all autocomplete lists in the document,
            except the one passed as an argument:*/
            search_results.innerHTML = '';
            search_results.classList.remove('active');
            search_field.removeAttribute('aria-activedescendant');
        }

        /*execute a function when someone clicks in the document:*/
        document.addEventListener("click", function (e) {
            closeAllLists(e.target);
        });
    }

	return {
		init : init
	};

}();